module.exports = __webpack_public_path__ + "static/media/kuibishan4.44773daa.webp";